"use client";

import React from "react";
import { CircleCheck, CreditCard, CircleQuestionMark, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const servicesData = [{
  id: 1,
  title: "Diritto Societario",
  description: "Consulenza strategica per la costituzione, governance e operazioni straordinarie, garantendo la massima tutela degli interessi aziendali.",
  duration: "Consulenza Senior"
}, {
  id: 2,
  title: "Responsabilità 231",
  description: "Implementazione di modelli organizzativi e gestione della compliance per prevenire la responsabilità amministrativa degli enti.",
  duration: "Compliance Integrata"
}, {
  id: 3,
  title: "Contenzioso Civile",
  description: "Difesa tecnica e rappresentanza in sede giudiziale e arbitrale, con un approccio orientato alla risoluzione efficiente delle controversie.",
  duration: "Assistenza Legale"
}, {
  id: 4,
  title: "Diritto del Lavoro",
  description: "Gestione delle relazioni industriali, contrattualistica e assistenza nelle fasi di ristrutturazione o crisi d'impresa.",
  duration: "Supporto HR"
}];
const faqData = [{
  id: 1,
  question: "Come viene strutturato il primo incontro conoscitivo?",
  answer: "Il primo incontro è finalizzato all'analisi preliminare della questione legale. Valutiamo i documenti, definiamo i possibili percorsi d'azione e forniamo un preventivo trasparente basato sulla complessità dell'incarico."
}, {
  id: 2,
  question: "Lo Studio opera anche a livello internazionale?",
  answer: "Sì, grazie a una rete consolidata di partner internazionali, offriamo assistenza legale e consulenza per operazioni transfrontaliere, garantendo competenza nelle diverse giurisdizioni coinvolte."
}, {
  id: 3,
  question: "Quali sono le modalità di determinazione del compenso?",
  answer: "I compensi sono definiti in conformità ai parametri forensi vigenti, privilegiando la trasparenza. Possiamo concordare tariffe orarie, forfait per singole pratiche o convenzioni per consulenza continuativa."
}, {
  id: 4,
  question: "È possibile ricevere consulenza in modalità telematica?",
  answer: "Assolutamente sì. Utilizziamo piattaforme certificate per garantire la massima riservatezza e sicurezza dei dati durante le sessioni di consulenza video, agevolando le necessità di flessibilità dei clienti."
}, {
  id: 5,
  question: "Come viene garantita la riservatezza dei dati aziendali?",
  answer: "Il segreto professionale è il pilastro del nostro operato. Adottiamo protocolli rigorosi di cybersecurity e archiviazione criptata per proteggere ogni informazione sensibile condivisa con lo Studio."
}];
const billingData = [{
  id: 1,
  service: "Parere Legale Scritto",
  duration: "Analisi Tecnica",
  fee: "Su Preventivo",
  description: "Esame approfondito della fattispecie con indicazione delle strategie."
}, {
  id: 2,
  service: "Assistenza in Udienza",
  duration: "Fase Giudiziale",
  fee: "Parametri Forensi",
  description: "Rappresentanza e difesa tecnica presso le autorità competenti."
}, {
  id: 3,
  service: "Consulenza Continuativa",
  duration: "Canone Mensile",
  fee: "Personalizzato",
  description: "Supporto legale day-by-day per le necessità ordinarie d'impresa."
}, {
  id: 4,
  service: "Due Diligence Legale",
  duration: "Project Based",
  fee: "Inquire",
  description: "Audit completo per operazioni di acquisizione o fusione."
}];
export default function Faq() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}